import { render } from "./legoCheckboxWrapper.vue?vue&type=template&id=3fb820cb"
import script from "./legoCheckboxWrapper.vue?vue&type=script&lang=js"
export * from "./legoCheckboxWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoCheckbox/legoCheckboxWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fb820cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fb820cb', __exports__)) {
    api.reload('3fb820cb', __exports__)
  }
  
  module.hot.accept("./legoCheckboxWrapper.vue?vue&type=template&id=3fb820cb", () => {
    api.rerender('3fb820cb', render)
  })

}


export default __exports__